export default "__VITE_ASSET__fd106a91__"